import React from 'react';
import { Typography } from '@mui/material';
import EnvironmentVariablesInline from './EnvironmentVariablesInline';

/**
 * Environment detail variables: inline Key / Value / Description (no modal).
 * Only environment-scoped variables are listed and edited here.
 */
export const EnvironmentVariablesPage = ({ environmentId, projectId }) => {
  if (!environmentId) {
    return (
      <Typography variant="body2" color="text.secondary">
        Select an environment to manage variables.
      </Typography>
    );
  }

  return <EnvironmentVariablesInline environmentId={environmentId} projectId={projectId} />;
};
